import { useEffect, useState } from "react";
import "../Common/css/styles.css";
import text from "../Assets/Text/Text.json";
import React from "react";

import s1 from "../Assets/Images/s1.jpg";
import s2 from "../Assets/Images/s2.jpg";
import s3 from "../Assets/Images/s3.jpg";
import s4 from "../Assets/Images/s4.jpg";
import s5 from "../Assets/Images/s5.jpg";

import f1 from "../Assets/Images/fc1.jpg";
import f2 from "../Assets/Images/fc2.jpg";
import { useNavigate } from "react-router-dom";
import { getInstructors } from "src/Services/instructor_api";

const images = [s1, s2, s3, s4, s5];
const freeImages = [f1, f2];

export const Courses = () => {
  const subjects = JSON.parse(sessionStorage.getItem("subjects") || "[]");
  const freeCourses = JSON.parse(sessionStorage.getItem("freeCourses") || "[]");
  const stream = sessionStorage.getItem("stream") || "N/A";
  const programme = sessionStorage.getItem("programme") || "N/A";
  const navigate = useNavigate();

  const token = sessionStorage.getItem("token") || "";

  // State to track which instructor bubble is open
  const [openInstructor, setOpenInstructor] = useState<string | null>(null);
  const [instructors, setInstructors] = useState<any[]>([]);
  const [freeCourseProgramme, setFreeCourseProgramme] = useState<string>("");
  const [freeCourseStream, setFreeCourseStream] = useState<string>("");

  useEffect(() => {}, []);

  const handleCourseClick = (course: string, stream: string) => {
    navigate("/subject", { state: { course } });
    sessionStorage.setItem("stream1", stream);
  };

  // Example instructor data
  const instructorsMap: Record<string, string[]> = {
    "Math": ["John Doe", "Jane Smith"],
    "Physics": ["Albert Einstein", "Marie Curie"],
    "Chemistry": ["Rosalind Franklin", "Dmitri Mendeleev"],
    // Add for other courses
  };

  const toggleInstructorBubble = (course: string) => {
    setOpenInstructor(openInstructor === course ? null : course);
  };

  const renderInstructorBubble = (course: string) => {
    const instructors = instructorsMap[course] || ["No instructors"];
    return (
      <div className="instructor-bubble">
        {instructors.map((ins, i) => (
          <div key={i} className="instructor-name">{ins}</div>
        ))}
      </div>
    );
  };

  const handleGetInstructors = async (programme: string, stream: string, subject: string) => {
    try {
        const res = await getInstructors(programme,stream,subject,token)
        setInstructors(res.data);
    } catch (error) {
        setInstructors([]);
    }
  };

  const returnFreeCoursesValues = (course:any, stream:any) => {

    if (course === "English Certificate"){
        setFreeCourseProgramme("Certificate course");
        setFreeCourseStream("Certificate course in English");
        handleCourseClick("Certificate course : Certificate course in English", "Certificate course in English");
    } else if (course === "IT Certificate"){
        setFreeCourseProgramme("Certificate course");
        setFreeCourseStream("Certificate course in ICT");
        handleCourseClick("Certificate course : Certificate course in ICT", "Certificate course in ICT");
    } else if (course === "English diploma"){
        setFreeCourseProgramme("Diploma");
        setFreeCourseStream("Diploma in English");
        handleCourseClick("Diploma : Diploma in English", "Diploma in English");
    } else if (course === "IT diploma"){
        setFreeCourseProgramme("Diploma");
        setFreeCourseStream("Diploma in ICT");
        handleCourseClick("Diploma : Diploma in ICT", "Diploma in ICT");
    } else if(course === "HRM diploma"){
        setFreeCourseProgramme("Diploma");
        setFreeCourseStream("Diploma in HRM");
        handleCourseClick("Diploma : Diploma in HRM", "Diploma in HRM");
    } else if (course === "Marketing diploma"){
        setFreeCourseProgramme("Diploma");
        setFreeCourseStream("Diploma in Marketing");
        handleCourseClick("Diploma : Diploma in Marketing", "Diploma in Marketing");
    }
    
  }

  return (
    <div className="comman-outer">
      <div className="comman-header-outer">
        <span className="stream-title-text">{stream}</span>
      </div>

      {subjects.length === 0 ? (
        <div className="course-card">
          <img
            src={images[1] || s1}
            className="course-image"
            onClick={() =>
              handleCourseClick(programme + " : " + stream, stream)
            }
          />
          <div className="subject-name">
            <h3 className="course-title">{stream}</h3>
          </div>
          <div className="subject-name1">
            {openInstructor === programme + " : " + stream &&
              renderInstructorBubble(programme + " : " + stream)}
          </div>
        </div>
      ) : (
        <div className="courses-container">
          {subjects.map((subject: string, index: number) => (
            <div key={index} className="course-card">
              <img
                src={images[index] || s1}
                alt={subject}
                className="course-image"
                onClick={() =>
                  handleCourseClick(programme + " : " + subject, stream)
                }
              />
              <div className="subject-name">
                <h3 className="course-title">
                  {programme} - {subject}
                </h3>
              </div>
            </div>
          ))}
        </div>
      )}

      {freeCourses.length !== 0 && (
        <div className="comman-header-outer top-margin">
          <span className="stream-title-text">{text.courses.otherCourses}</span>
        </div>
      )}

      <div className="courses-container">
        {freeCourses.map((course: string, index: number) => (
          <div key={index} className="course-card">
            <img
              src={freeImages[index] || f1}
              alt={course}
              className="course-image"
              onClick={() => {
                returnFreeCoursesValues(course, stream)
            }}
            />
            <div className="subject-name">
              <h3 className="course-title">{course}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
